import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

// eslint-disable-next-line react/prop-types
function MyRoute({ isClosed, children }) {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  if (isClosed && !isLoggedIn) {
    toast.warning('Para realizar essa atividade, Você precisa estar logado!');
    return <Navigate to="/" replace />;
  }

  return children;
}

export default MyRoute;
